import { ROUTES } from "@shared/routes";

const STORAGE_KEY = "nablow.returnTo";
const LABEL_KEY = "nablow.returnToLabel";

const isClassPath = (path: string): boolean =>
  path.startsWith(ROUTES.classPrefix) && !path.startsWith("//") && !path.includes("://");

export const rememberReturnTo = (path: string, label?: string): void => {
  if (!isClassPath(path)) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, path);
    if (label) sessionStorage.setItem(LABEL_KEY, label);
    else sessionStorage.removeItem(LABEL_KEY);
  } catch {
    return;
  }
};

export const peekReturnLabel = (): string | null => {
  try {
    return sessionStorage.getItem(STORAGE_KEY) ? sessionStorage.getItem(LABEL_KEY) : null;
  } catch {
    return null;
  }
};

export const takeReturnTo = (): string => {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
    sessionStorage.removeItem(LABEL_KEY);
    return stored && isClassPath(stored) ? stored : ROUTES.home;
  } catch {
    return ROUTES.home;
  }
};
